import MuiAccordionDetails from "@mui/material/AccordionDetails";
const AccordionDetails = MuiAccordionDetails;
export default AccordionDetails;
